import React from 'react'
import { FormControl } from 'react-bootstrap'
import { join, replace, split, trim, map } from 'lodash'

export function listToString(value) {
  if (value) {
    let input = join(value, '\\n')
    let newLine = String.fromCharCode(13, 10)
    return replace(input, /\\n/g, newLine)
  } else {
    return ''
  }
}

export default class ContentReferenceInput extends React.Component {

  constructor(props) {
    super(props)
    this.state = { value: listToString(props.value) }
  }

  componentDidUpdate(){
    this.setState({
      value: listToString(this.props),
    })
  }

  onChange(value) {
    let newValue = split(value, /\n|,/g)
    newValue = map(newValue, trim)
    this.props.onChange(newValue)

    this.setState({ value })
  }

  render() {
    const { value } = this.state
    return <FormControl 
            autoFocus 
            componentClass='textarea' 
            value={value} 
            onChange={(e) => this.onChange(e.target.value)} 
          />
  }
}
